import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Appeal {
  id: string;
  orderId: string;
  status: string;
  reason?: string;
  comment?: string;
  requireClientInvoice: boolean;
  requireTraderInvoice: boolean;
  ttl: number;
  isBlocked: boolean;
  images?: string;
  videos?: string;
  documents?: string;
  createdAt: string;
  updatedAt: string;
  order?: any;
}

interface AppealState {
  appeals: Appeal[];
  currentAppeal: Appeal | null;
  loading: boolean;
  error: string | null;
}

const initialState: AppealState = {
  appeals: [],
  currentAppeal: null,
  loading: false,
  error: null,
};

const appealSlice = createSlice({
  name: "appeal",
  initialState,
  reducers: {
    setAppeals: (state, action: PayloadAction<Appeal[]>) => {
      state.appeals = action.payload;
    },
    setCurrentAppeal: (state, action: PayloadAction<Appeal>) => {
      state.currentAppeal = action.payload;
    },
    addAppeal: (state, action: PayloadAction<Appeal>) => {
      state.appeals.push(action.payload);
    },
    updateAppeal: (
      state,
      action: PayloadAction<Partial<Appeal> & { id: string }>
    ) => {
      const index = state.appeals.findIndex((a) => a.id === action.payload.id);
      if (index !== -1) {
        state.appeals[index] = { ...state.appeals[index], ...action.payload };
      }
      if (state.currentAppeal?.id === action.payload.id) {
        state.currentAppeal = { ...state.currentAppeal, ...action.payload };
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setAppeals,
  setCurrentAppeal,
  addAppeal,
  updateAppeal,
  setLoading,
  setError,
} = appealSlice.actions;

export default appealSlice.reducer;
